module.exports = __webpack_public_path__ + "static/media/18_l_wall_0_0.c7850e6c.png";